import React, { useState, useEffect } from 'react';
import {
    FaArrowCircleDown, FaArrowCircleUp,
    FaBan, FaCar,
    FaCheck, FaComment,
    FaCopy,
    FaDownload,
    FaEdit,
    FaFileAlt,
    FaFileContract,
    FaFilePrescription,
    FaInfo, FaPen, FaPenFancy, FaSort, FaSpeakap,
    FaTimes,
    FaTrash, FaWrench
} from 'react-icons/fa';
import './Overview.css';
import {useDispatch, useSelector} from "react-redux";
import FormSummary from "./FormSummary";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
import {Form, OverlayTrigger, Tooltip} from "react-bootstrap";
import {
    changeContractRequest,
    confirmContractRequest,
    copyContractRequest,
    deleteContractRequest,
    getContractsRequest, setSchoolYearRequest
} from "../redux/actions/contractActions";
import {
    getActualSchoolYearRequest,
    getNextSchoolYearRequest, getPreviousSchoolYearRequest,
    getSchoolYearsRequest
} from "../redux/actions/jointPowersActions";
import {confirmEmploymentRequest, updateEmploymentUnitsRequest} from "../redux/actions/employmentActions";
import {FaAnchorCircleXmark, FaExplosion, FaHand} from "react-icons/fa6";
import StopContractForm from "./StopContractForm";
import {downloadFile as apiDownloadFile} from "../redux/utils/api";
import SchoolCommentForm from "./SchoolCommentForm";
import ChartComponent from "./statistics/ChartComponent";

function Overview() {
    const [editEmployment, setEditEmployment] = useState(null);
    const [editValue, setEditValue] = useState('');
    const [editTeachingValue, setEditTeachingValue] = useState('');
    const [sortField, setSortField] = useState('');
    const [sortOrder, setSortOrder] = useState('asc');

    const dispatch = useDispatch();
    const contracts = useSelector(state => state.contract.contracts);
    const contractsLoaded = useSelector(state => state.contract.contractsLoaded);
    const isLoadingGetContracts = useSelector(state => state.contract.loading.getContracts);
    const userGroups = useSelector(state => state.authentication.userGroups);
    const authToken = useSelector(state => state.authentication.authToken);
    const schoolYears = useSelector(state => state.jointPower.schoolYears);
    const isLoadingGetSchoolYears = useSelector(state => state.jointPower.loading.getSchoolYears);
    const selectedSchoolYear = useSelector(state => state.contract.selectedSchoolYearID);
    const selectedRole = useSelector(state => state.authentication.selectedRole);
    const nextSchoolYear = useSelector(state => state.jointPower.nextSchoolYear);
    const actualSchoolYear = useSelector(state => state.jointPower.actualSchoolYear);
    const previousSchoolYear = useSelector(state => state.jointPower.previousSchoolYear);

    const isEditableGroup = selectedRole ? (selectedRole === 'institute' || selectedRole === 'rectorate') : userGroups.includes('institute') || userGroups.includes('rectorate')
    const isRectorate = selectedRole ? selectedRole === 'rectorate' : userGroups.includes('rectorate');
    const isSchool = selectedRole ? selectedRole === 'school' : userGroups.includes('school');
    const isInstitute = selectedRole ? (selectedRole === 'institute' || selectedRole === 'assistatnt') : (userGroups.includes('institute') || userGroups.includes('assistant'));
    const isStaffMembers = selectedRole ? selectedRole === 'staffmembers' : userGroups.includes('staffmembers');
    const isHR = selectedRole ? selectedRole === 'humanressource' : userGroups.includes('humanressource');
    const [searchTerm, setSearchTerm] = useState('');
    const [contractToShow, setContractToShow] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [contractToDelete, setContractToDelete] = useState(null);
    const [contractToStop, setContractToStop] = useState(null);
    const [schoolComment, setSchoolComment] = useState(null);
    const [activeColumns, setActiveColumns] = useState({
        Nachname: false,
        Vorname: false,
        Email: false,
        Institut: false,
        Status: false,
        federalState: false,
    });
    const [expandedRows, setExpandedRows] = useState({});
    const [allExpanded, setAllExpanded] = useState(true); // State, um den Zustand aller Zeilen zu verfolgen
    const [selectedContracts, setSelectedContracts] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const STATUS_MAP = {
        'NONE': 'OEL initiiert',
        'INITIATED': 'MV Daten erfasst',
        'INSTITUTE': 'OEL bestätigt',
        'RECTORATE': 'Rektorat bestätigt',
        'SCHOOL': 'Schule bestätigt',
        'FEDERALSTATE': 'Land bestätigt',
        'STOPPED': 'Beendet'
    };

    const STATE_OR_FEDERAL_MAP = {
        'STATE': 'Bund',
        'FEDERAL': 'Land'
    };

    const handleSortedContracts = () => {
        return [...contracts].sort((a, b) => {
            if (!sortField) return 0;

            let aField, bField;
            switch (sortField) {
                case 'Nachname':
                    aField = a.employee.FamilyName?.toLowerCase();
                    bField = b.employee.FamilyName?.toLowerCase();
                    break;
                case 'Vorname':
                    aField = a.employee.GivenName?.toLowerCase();
                    bField = b.employee.GivenName?.toLowerCase();
                    break;
                case 'Email':
                    aField = a.employee.InitialEmail?.toLowerCase();
                    bField = b.employee.InitialEmail?.toLowerCase();
                    break;
                case 'Status':
                    aField = a.contract.Status?.toLowerCase();
                    bField = b.contract.Status?.toLowerCase();
                    break;
                case 'Institut':
                    const leadingA = getLeadingEmployment(a.employments);
                    const leadingB = getLeadingEmployment(b.employments);
                    aField = leadingA ? leadingA.orgUnit.Name?.toLowerCase() : '';
                    bField = leadingB ? leadingB.orgUnit.Name?.toLowerCase() : '';
                    break;
                case 'federalState':
                    aField = a.federalState.Name?.toLowerCase();
                    bField = b.federalState.Name?.toLowerCase();
                    break;
                case 'stateOrFederal':
                    aField = a.contract.StateOrFederal?.toLowerCase();
                    bField = b.contract.StateOrFederal?.toLowerCase();
                    break;
                default:
                    return 0;
            }

            if (aField < bField) return sortOrder === 'asc' ? -1 : 1;
            if (aField > bField) return sortOrder === 'asc' ? 1 : -1;
            return 0;
        });
    }
    const sortedContracts = handleSortedContracts();


    useEffect(() => {
        if(contracts.length === 0 && !isLoadingGetContracts && !contractsLoaded) {
            dispatch(getContractsRequest({ "selectedRole": selectedRole }));
        }
    }, [dispatch, contracts.length, isLoadingGetContracts, contractsLoaded, selectedRole]);

    useEffect(() => {
        if (selectedSchoolYear) {
            dispatch(getContractsRequest({"selectedSchoolYear" : selectedSchoolYear, "selectedRole": selectedRole }));
        }
    }, [selectedSchoolYear, dispatch, selectedRole]);

    useEffect(() => {
        if (!schoolYears.length && !isLoadingGetSchoolYears) {
            dispatch(getSchoolYearsRequest());
        }
    }, [dispatch, schoolYears?.length, isLoadingGetSchoolYears]);

    useEffect(() => {
        if (!nextSchoolYear) {
            dispatch(getNextSchoolYearRequest());
        }
    }, [nextSchoolYear, dispatch]);

    useEffect(() => {
        if (!actualSchoolYear) {
            dispatch(getActualSchoolYearRequest());
        }
    }, [actualSchoolYear, dispatch]);

    useEffect(() => {
        if (!previousSchoolYear) {
            dispatch(getPreviousSchoolYearRequest());
        }
    }, [previousSchoolYear, dispatch]);



    const setSelectedSchoolYear = (schoolYearID) => {
        dispatch(setSchoolYearRequest(schoolYearID))
    }

    const handleEditChange = (e) => {
        setEditValue(e.target.value);
    };

    const handleEditTeachingChange = (e) => {
        setEditTeachingValue(e.target.value);
    };

    const handleSort = (field) => {
        const newSortOrder = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
        setSortField(field);
        setSortOrder(newSortOrder);
    };

    const handleToggleColumn = (columnName) => {
        setActiveColumns(prevState => ({
            ...prevState,
            [columnName]: !prevState[columnName],
        }));
    };

    const handleSelectContract = (contractID) => {
        console.log(contractID);
        setSelectedContracts(prev => {
            if (prev.includes(contractID)) {
                return prev.filter(id => id !== contractID);
            } else {
                return [...prev, contractID];
            }
        });
    };

    const handleSelectAllChange = (e) => {
        const newSelectAll = e.target.checked;
        setSelectAll(newSelectAll);

        if (newSelectAll) {
            // Alle auswählen
            const allIDs = sortedContracts.map(contract => contract.contract.ID);
            setSelectedContracts(allIDs);
        } else {
            // Alle abwählen
            setSelectedContracts([]);
        }
    };

    // Funktion, um den Zustand des Ein-/Ausklappens einzelner Zeilen umzuschalten
    const toggleRowExpansion = (index) => {
        setExpandedRows((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    // Funktion, um alle Zeilen ein- oder auszuklappen
    const toggleAllRows = () => {
        const newState = {};
        sortedContracts.forEach((_, index) => {
            newState[index] = !allExpanded; // Setzt den Zustand basierend auf allExpanded
        });
        setExpandedRows(newState);
        setAllExpanded(!allExpanded); // Ändert den Zustand für alle Zeilen
    };

    function getLeadingEmployment(employments) {
        const leading = employments.find(emp => emp.IsLeading === true || emp.IsLeading === 1);
        return leading || employments[0];
    }

    const saveEdit = () => {
        if (editEmployment) {
            // Senden der Anfrage an den Server
            contracts.filter(contract => contract.contract.ID === editEmployment.contractId).forEach(contract => {
                contract.employments.filter(employment => employment.employment.ID === editEmployment.employmentId).forEach(employment => {
                    dispatch(updateEmploymentUnitsRequest(editEmployment.employmentId, editValue, editTeachingValue));
                });
            });
        }
        setEditEmployment(null);
    };

    const handleEmploymentConfirmation = (employmentID, contractID, status) => {
        if (isEditableGroup) {
            dispatch(confirmEmploymentRequest({employmentID, contractID, status, selectedRole}));
        }
    };

    const handleContractConfirmation = (contractID, status) => {
        if (isRectorate || isSchool) {
            dispatch(confirmContractRequest({contractID, status}));
        }
    }

    const saveBlobResponse = async (response, fileName) => {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;

        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);
    };

    const downloadFile = async (contractID, fileType) => {
        let apiUrl;
        let fileName;

        switch (fileType) {
            case 'PDF':
                apiUrl = `/jointpower-api/getPDF/${contractID}`;
                fileName = "contract.pdf";
                break;
            case 'BBA':
                apiUrl = `/jointpower-api/getBBA/${contractID}`;
                fileName = "bba.pdf";
                break;
            case 'DBD':
                apiUrl = `/jointpower-api/getDBD/${contractID}`;
                fileName = "dbd.pdf";
                break;
            case 'TRAVEL':
                apiUrl = `/jointpower-api/getTravel/${contractID}`;
                fileName = "travel.pdf";
                break;
            default:
                console.error("Unbekannter Dateityp");
                return;
        }

        try {
            const response = await apiDownloadFile(apiUrl);
            await saveBlobResponse(response, fileName);
        } catch (e) {
            console.error(`Fehler beim Herunterladen der Datei: ${fileType}`, e);
        }
    };

    const downloadAll = async () => {
        const apiUrl = `/jointpower-api/getAllPDFs`;
        const fileName = "all.zip";

        const collectedIDs = sortedContracts
            .filter((contractEntry) => {
                const term = searchTerm.toLowerCase();
                return (
                    contractEntry.employee.InitialEmail.toLowerCase().includes(term) ||
                    contractEntry.employee.FamilyName?.toLowerCase().includes(term) ||
                    contractEntry.employee.GivenName?.toLowerCase().includes(term)
                );
            })
            .map((contractEntry) => contractEntry.contract.ID);

        try {
            const response = await apiDownloadFile(apiUrl, {
                method: 'POST',
                data: { contractIDs: collectedIDs },
                timeoutMs: 120000,
            });

            await saveBlobResponse(response, fileName);
        } catch (e) {
            console.error("Fehler beim Herunterladen aller PDFs", e);
        }
    };

    const resetContractToShow = () => {
        setContractToShow(null);
    }

    const setContractToShowHandler = (contract) => {
        setContractToShow({ ...contract });
    };

    const requestDeleteContract = (contract) => {
        setContractToDelete({...contract });
        setShowConfirmModal(true);
    };

    const requestCopyContract = (contract) => {
        dispatch(copyContractRequest(contract.ID));
    };

    const requestFinishContract = (contract) => {
        setContractToStop({...contract});
    }

    const requestChangeContract = (contract) => {
        dispatch(changeContractRequest(contract.ID));
    }

    const requestSchoolComment = (contract) => {
        setSchoolComment({...contract});
    }

    const confirmDeleteContract = () => {
        if (contractToDelete) {
            dispatch(deleteContractRequest(contractToDelete.ID));
            setContractToDelete(null);
            setShowConfirmModal(false);
        }
    };

    const copyAllSelectedContracts = () => {
        if (selectedContracts.length === 0) {
            contracts.forEach(contract => {
                dispatch(copyContractRequest(contract.contract.ID));
            });
        } else {
            selectedContracts.forEach(contractID => {
                dispatch(copyContractRequest(contractID));
            });
        }
    };

    const searchContract = (contractEntry) => {
        const term = searchTerm.toLowerCase();

        // Überprüfen, ob keine Spalten aktiv sind
        const noActiveColumns = Object.values(activeColumns).every(value => value === false);

        // Allgemeine Überprüfung aller Felder, wenn keine Spalten aktiv sind
        if (noActiveColumns) {
            return (
                contractEntry.employee.InitialEmail?.toLowerCase().includes(term) ||
                contractEntry.employee.FamilyName?.toLowerCase().includes(term) ||
                contractEntry.employee.GivenName?.toLowerCase().includes(term) ||
                contractEntry.employments.some(employment => {
                    return employment.orgUnit.Name?.toLowerCase().includes(term) ||
                        employment.employment.JobTitle?.toLowerCase().includes(term) ||
                        (employment.employment.NumOfUnitsTeaching && "lehrend".includes(term)) ||
                        (employment.employment.NumOfUnits && "planend".includes(term));
                }) ||
                contractEntry.contract.Status.toLowerCase().includes(term) ||
                contractEntry.federalState.Name.toLowerCase().includes(term)
            );
        }

        // Suche in aktivierten Spalten, falls eine oder mehrere Spalten aktiv sind
        return (
            (activeColumns.Email && contractEntry.employee.InitialEmail.toLowerCase().includes(term)) ||
            (activeColumns.Nachname && contractEntry.employee.FamilyName?.toLowerCase().includes(term)) ||
            (activeColumns.Vorname && contractEntry.employee.GivenName?.toLowerCase().includes(term)) ||
            (activeColumns.Institut && contractEntry.employments.some(employment => {
                return employment.orgUnit.Name?.toLowerCase().includes(term) ||
                    employment.employment.JobTitle?.toLowerCase().includes(term) ||
                    (employment.employment.NumOfUnitsTeaching && "lehrend".includes(term)) ||
                    (employment.employment.NumOfUnits && "planend".includes(term));
            })) ||
            (activeColumns.Status && contractEntry.contract.Status.toLowerCase().includes(term)) ||
            (activeColumns.federalState && contractEntry.federalState.Name.toLowerCase().includes(term))
        );
    };

    const getColorOfState = (contractEntry) => {
        if (contractEntry.contract.Status === 'RECTORATE') {
            return 'state-green';
        }
        if (contractEntry.contract.Status === 'INSTITUTE' || contractEntry.contract.Status === 'INITIATED') {
            return 'state-yellow';
        }
        if (contractEntry.contract.Status === 'NONE') {
            return 'state-red';
        }
    }

    const filteredContracts = sortedContracts.filter(contractEntry => searchContract(contractEntry));
    const instituteTotals = {};
    filteredContracts.forEach((contractEntry) => {
        contractEntry.employments.forEach((employment) => {
            const totalUnits = (employment.employment.NumOfUnits || 0)
                + (employment.employment.NumOfUnitsTeaching || 0);

            // Falls mal kein Institut gesetzt ist, verwende einen Default-Namen:
            const instituteName = employment.orgUnit?.Name || "Unbekanntes Institut";

            if (!instituteTotals[instituteName]) {
                instituteTotals[instituteName] = 0;
            }
            instituteTotals[instituteName] += totalUnits;
        });
    });
    const totalAllInstitutes = Object.values(instituteTotals).reduce((acc, val) => acc + val, 0);

    return (
        <>
            <ConfirmDeleteModal
                show={showConfirmModal}
                onHide={() => setShowConfirmModal(false)}
                onConfirm={confirmDeleteContract}
            />
            {contractToStop && (
                <StopContractForm contract={contractToStop} setContractToStop={setContractToStop} />
            )}
            {contractToShow && (
                <div className="container contract-details">
                    <div className="row header-row d-none d-md-flex">
                        <div className="col">
                            <FormSummary contract={contractToShow} setCurrentStep="" previousStep={resetContractToShow} submitButtonText="" />
                        </div>
                    </div>
                </div>
            )}
            {schoolComment && (
                <SchoolCommentForm contract={schoolComment} setSchoolComment={setSchoolComment}/>
            )}
            {!contractToShow && !contractToStop && !schoolComment && (
                <div className="container employee-details">
                    <h2 className="text-center my-4">Übersicht der Mitverwendungen</h2>
                    <div className="row mb-3">
                        <div className="col-12 col-md-4">
                            <div className="search-input">
                                <input
                                    type="text"
                                    placeholder="Suche..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            &nbsp;
                        </div>
                        <div className="col-12 col-md-4">
                            <select
                                className="form-select"
                                value={selectedSchoolYear}
                                onChange={(e) => setSelectedSchoolYear(e.target.value)}
                            >
                                <option value="" disabled="disabled">Schuljahr</option>
                                {schoolYears.map((year) => (
                                    <option key={year.ID} value={year.ID}>{year.Name}</option>
                                ))}
                            </select>
                        </div>

                    </div>
                    <div className="row header-row d-flex">
                        <div className="col-12 col-md-1">
                            <span className="m-1">
                                <input
                                    type="checkbox"
                                    checked={selectAll}
                                    onChange={handleSelectAllChange}
                                />
                            </span>
                            <span className="m-1">
                            {!isStaffMembers && contracts.length > 0 &&
                                <OverlayTrigger
                                    key="all-download"
                                    placement="top"
                                    overlay={<Tooltip id={`tooltip-alldownload`}>Markierte vom Rektorat genehmigten
                                        Mitverwendungen
                                        herunterladen</Tooltip>}
                                >
                                    <a target="_blank" rel="noopener noreferrer" className="download-link"
                                       onClick={() => downloadAll()}>
                                        <strong><FaDownload/></strong>
                                    </a>
                                </OverlayTrigger>
                            }
                            </span>
                            <span className="m-1">
                            {!isStaffMembers && contracts.length > 0 &&
                                <OverlayTrigger
                                    key="all-download"
                                    placement="top"
                                    overlay={<Tooltip id={`tooltip-alldownload`}>Markierte Mitverwendungen kopieren
                                    </Tooltip>}
                                >
                                    <a target="_blank" rel="noopener noreferrer" className="download-link"
                                       onClick={() => copyAllSelectedContracts()}>
                                        <strong><FaCopy/></strong>
                                    </a>
                                </OverlayTrigger>
                            }
                            </span>
                        </div>
                        <div className="col-6 col-md-1">
                            <strong className="inline-flex">
                                <span className="w-50-mobile mb-3 mb-md-0">Nachname</span>
                                <FaSort className="mb-3 mb-md-0 ms-3 ms-md-0" onClick={() => handleSort('Nachname')}/>
                                <Form.Check className="mb-3 mb-md-0 ms-3 ms-md-0"
                                            onChange={() => handleToggleColumn('Nachname')}></Form.Check>
                            </strong>
                        </div>
                        <div className="col-6 col-md-1">
                            <strong className="inline-flex">
                                <span className="w-50-mobile mb-3 mb-md-0">Vorname</span>
                                <FaSort className="mb-3 mb-md-0 ms-3 ms-md-0" onClick={() => handleSort('Vorname')}/>
                                <Form.Check className="mb-3 mb-md-0 ms-3 ms-md-0"
                                            onChange={() => handleToggleColumn('Vorname')}></Form.Check></strong>
                        </div>
                        <div className="col-6 col-md-1">
                            <strong className="inline-flex">
                                <span className="w-50-mobile mb-3 mb-md-0">Email</span>
                                <FaSort className="mb-3 mb-md-0 ms-3 ms-md-0" onClick={() => handleSort('Email')}/>
                                <Form.Check className="mb-3 mb-md-0 ms-3 ms-md-0"
                                            onChange={() => handleToggleColumn('Email')}></Form.Check></strong>
                        </div>
                        <div className="col-6 col-md-3">
                            <strong className="inline-flex">
                                <div className="w-50-mobile mb-3 mb-md-0">Institut</div>
                                <FaSort className="mb-3 mb-md-0 ms-3 ms-md-0" onClick={() => handleSort('Institut')}/>
                                <Form.Check className="mb-3 mb-md-0 ms-3 ms-md-0"
                                            onChange={() => handleToggleColumn('Institut')}></Form.Check></strong>
                        </div>
                        <div className="col-6 col-md-1">
                            <strong className="inline-flex">
                                <div className="w-50-mobile mb-3 mb-md-0">Land</div>
                                <FaSort className="mb-3 mb-md-0 ms-3 ms-md-0"
                                        onClick={() => handleSort('federalState')}/>
                                <Form.Check className="mb-3 mb-md-0 ms-3 ms-md-0"
                                            onChange={() => handleToggleColumn('federalState')}></Form.Check></strong>
                        </div>
                        <div className="col-6 col-md-1">
                            <strong className="inline-flex">
                                <div className="w-50-mobile mb-3 mb-md-0">Anstellung</div>
                                <FaSort className="mb-3 mb-md-0 ms-3 ms-md-0"
                                        onClick={() => handleSort('stateOrFederal')}/>
                                <Form.Check className="mb-3 mb-md-0 ms-3 ms-md-0"
                                            onChange={() => handleToggleColumn('stateOrFederal')}></Form.Check></strong>
                        </div>
                        <div className="col-6 col-md-1">
                            <strong className="inline-flex">
                                <div className="w-50-mobile mb-3 mb-md-0">Status</div>
                                <FaSort className="mb-3 mb-md-0 ms-3 ms-md-0" onClick={() => handleSort('Status')}/>
                                <Form.Check className="mb-3 mb-md-0 ms-3 ms-md-0"
                                            onChange={() => handleToggleColumn('Status')}></Form.Check>
                            </strong>
                        </div>
                        <div className="col-12 col-md-1 text-end">
                            <span>
                                {allExpanded && (<FaArrowCircleDown onClick={toggleAllRows}/>)}
                                {!allExpanded && (<FaArrowCircleUp onClick={toggleAllRows}/>)}
                            </span>
                        </div>
                    </div>
                    {allExpanded && sortedContracts
                        .filter((contractEntry) => searchContract(contractEntry))
                        .map((contractEntry, index) => (
                            <div key={index} className={`row data-row ${getColorOfState(contractEntry)}`}>
                                <div className="col-12 col-md-1">
                                    <input
                                        type="checkbox"
                                        checked={selectedContracts.includes(contractEntry.contract.ID)}
                                        onChange={() => handleSelectContract(contractEntry.contract.ID)}
                                    />
                                </div>
                                <div className="col-12 col-md-1 inline-flex" style={{
                                    fontSize: "0.75rem",
                                    wordWrap: "break-word"
                                }}>
                                    <span className="d-block d-md-none"><strong>Nachname:</strong></span>
                                    {contractEntry.employee.FamilyName}
                                </div>
                                <div className="col-12 col-md-1 inline-flex" style={{
                                    fontSize: "0.75rem",
                                    wordWrap: "break-word"
                                }}>
                                    <span className="d-block d-md-none"><strong>Vorname:</strong></span>
                                    {contractEntry.employee.GivenName}
                                </div>
                                <div className="col-12 col-md-1 very-small-font" style={{
                                    wordWrap: "break-word"
                                }}>
                                    <span className="d-block d-md-none" style={{
                                        wordBreak: "break-all",
                                        overflowWrap: "anywhere"
                                    }}><strong>Email:</strong></span>
                                    {contractEntry.employee.InitialEmail}
                                </div>
                                <div className="col-12 col-md-3 small-font">
                                    <span className="d-block d-md-none"><strong>Institut:</strong></span>
                                    {contractEntry.employments.map((employmentEntry, empIndex) => (
                                        <div key={empIndex}>
                                            {editEmployment && editEmployment.employmentId === employmentEntry.employment.ID && isEditableGroup ? (
                                                <>
                                                    {employmentEntry.employment.NumOfUnitsTeaching > 0 &&
                                                        <input
                                                            type="number"
                                                            value={editTeachingValue}
                                                            onChange={handleEditTeachingChange}
                                                            onBlur={saveEdit}
                                                            step="0.01"
                                                        />
                                                    }
                                                    {employmentEntry.employment.NumOfUnits > 0 &&
                                                        <input
                                                            type="number"
                                                            value={editValue}
                                                            onChange={handleEditChange}
                                                            onBlur={saveEdit}
                                                            step="0.01"
                                                        />
                                                    }
                                                </>
                                            ) : (
                                                <div className="row">
                                                    <div className="col-4 very-small-font">
                                                        {employmentEntry.orgUnit.Name}
                                                    </div>
                                                    <div className="col-4 very-small-font"
                                                         style={{wordWrap: "break-word"}}>
                                                        {employmentEntry.employment.JobTitle}
                                                    </div>
                                                    <div className="col-4">
                                                        {employmentEntry.employment.NumOfUnitsTeaching > 0 &&
                                                            <div className="very-small-font"
                                                                 onClick={() => contractEntry.contract.Status !== "RECTORATE" && isEditableGroup}>
                                                                Lehre: {employmentEntry.employment.NumOfUnitsTeaching + employmentEntry.employment.UnitTypeTeaching}
                                                            </div>
                                                        }
                                                        {employmentEntry.employment.NumOfUnits > 0 &&
                                                            <div className="very-small-font"
                                                                 onClick={() => contractEntry.contract.Status !== "RECTORATE" && isEditableGroup}>
                                                                Planend: {employmentEntry.employment.NumOfUnits + employmentEntry.employment.UnitType}
                                                            </div>
                                                        }
                                                    </div>
                                                    {isEditableGroup && employmentEntry.employment.Status === 'INITIATED' && (
                                                        <div className="col-12 very-small-font text-end">
                                                            <OverlayTrigger
                                                                key={`deny-emp-${contractEntry.contract.ID}-${employmentEntry.employment.ID}`}
                                                                placement="top"
                                                                overlay={<Tooltip
                                                                    id={`tooltip-deny-emp-${contractEntry.contract.ID}`}>Mitverwendung
                                                                    ablehnen</Tooltip>}
                                                            >
                                                        <span
                                                            className="confirm-icon"
                                                            onClick={() => handleEmploymentConfirmation(employmentEntry.employment.ID, contractEntry.contract.ID, "INITIATED")}
                                                            style={{cursor: 'pointer', color: 'red'}}
                                                        >
                                                            <FaTimes/>
                                                        </span>
                                                            </OverlayTrigger>
                                                            <OverlayTrigger
                                                                key={`confirm-emp-${contractEntry.contract.ID}-${employmentEntry.employment.ID}`}
                                                                placement="top"
                                                                overlay={<Tooltip
                                                                    id={`tooltip-confirm-emp-${contractEntry.contract.ID}`}>Mitverwendung
                                                                    bestätigen</Tooltip>}
                                                            >
                                                        <span
                                                            className="confirm-icon"
                                                            onClick={() => handleEmploymentConfirmation(employmentEntry.employment.ID, contractEntry.contract.ID, "INSTITUTE")}
                                                            style={{
                                                                cursor: 'pointer',
                                                                color: 'green',
                                                                marginLeft: '10px'
                                                            }}
                                                        >
                                                            <FaCheck/>
                                                        </span>
                                                            </OverlayTrigger>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                                <div className="col-12 col-md-1 inline-flex" style={{fontSize: "0.75rem"}}>
                                    <span className="d-block d-md-none"><strong>Bundesland:</strong></span>
                                    {contractEntry.federalState.Shortname}
                                </div>
                                <div className="col-12 col-md-1 inline-flex" style={{fontSize: "0.75rem"}}>
                                    <span className="d-block d-md-none"><strong>Anstellung:</strong></span>
                                    {STATE_OR_FEDERAL_MAP[contractEntry.contract.StateOrFederal] || contractEntry.contract.StateOrFederal}
                                </div>
                                <div className="col-12 col-md-1 inline-flex" style={{fontSize: "0.75rem"}}>
                                    <span className="d-block d-md-none"><strong>Status:</strong></span>
                                    {STATUS_MAP[contractEntry.contract.Status] || contractEntry.contract.Status}
                                </div>
                                <div className="col-12 col-md-1 text-end text-md-start small-font">
                                    <div className="row">
                                        <div className="col-12">
                                            {(contractEntry.contract.Status === 'SCHOOL' || contractEntry.contract.Status === 'RECTORATE' || contractEntry.contract.Status === 'STOPPED') && (
                                                <span className="links">
                                                    <OverlayTrigger
                                                        key={`pdf-${contractEntry.contract.ID}`}
                                                        placement="top"
                                                        overlay={<Tooltip
                                                            id={`tooltip-pdf-${contractEntry.contract.ID}`}>Mitverwendung
                                                            herunterladen</Tooltip>}
                                                    >
                                                        <a
                                                            onClick={() => downloadFile(contractEntry.contract.ID, 'PDF')}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="download-link"
                                                        >
                                                            <FaFileContract></FaFileContract>
                                                        </a>
                                                    </OverlayTrigger>
                                                </span>
                                            )}
                                            {contractEntry.contract.Status === "RECTORATE" && (
                                                <span className="links">
                                                    <OverlayTrigger
                                                        key={`addition-${contractEntry.contract.ID}`}
                                                        placement="top"
                                                        overlay={<Tooltip
                                                            id={`tooltip-addition-${contractEntry.contract.ID}`}>Beiblatt
                                                            herunterladen</Tooltip>}
                                                    >
                                                        <a
                                                            onClick={() => downloadFile(contractEntry.contract.ID, 'BBA')}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="download-link"
                                                        >
                                                            <FaFileAlt></FaFileAlt>
                                                        </a>
                                                    </OverlayTrigger>
                                                </span>
                                            )}
                                            {((contractEntry.contract.Status === 'RECTORATE' || isHR || isRectorate) && contractEntry.federalState.Shortname === 'W') && (
                                                <span className="links">
                                                    <OverlayTrigger
                                                        key={`money-${contractEntry.contract.ID}`}
                                                        placement="top"
                                                        overlay={<Tooltip
                                                            id={`tooltip-money-${contractEntry.contract.ID}`}>Besoldung
                                                            herunterladen</Tooltip>}
                                                    >
                                                        <a
                                                            onClick={() => downloadFile(contractEntry.contract.ID, 'DBD')}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="download-link"
                                                        >
                                                            <FaFilePrescription></FaFilePrescription>
                                                        </a>
                                                    </OverlayTrigger>
                                                </span>
                                            )}
                                            {contractEntry.contract.Status === "RECTORATE" && contractEntry.federalState.Shortname !== 'W' && (
                                                <span className="links">
                                                    <OverlayTrigger
                                                        key={`addition-${contractEntry.contract.ID}`}
                                                        placement="top"
                                                        overlay={<Tooltip
                                                            id={`tooltip-addition-${contractEntry.contract.ID}`}>Reisekostenverzicht
                                                            herunterladen</Tooltip>}
                                                    >
                                                        <a
                                                            onClick={() => downloadFile(contractEntry.contract.ID, 'TRAVEL')}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="download-link"
                                                        >
                                                            <FaCar></FaCar>
                                                        </a>
                                                    </OverlayTrigger>
                                                </span>
                                            )}
                                            {isInstitute &&
                                                (   contractEntry.schoolYear.IsActive === 1 ||
                                                    contractEntry.schoolYear.ID === nextSchoolYear.ID ||
                                                    contractEntry.schoolYear.ID === previousSchoolYear.ID ||
                                                    contractEntry.contract.PostApprovalChangeDate
                                                ) &&
                                                contractEntry.contract.Status !== 'RECTORATE' &&
                                                contractEntry.contract.Status !== 'SCHOOL' &&
                                                contractEntry.contract.Status !== 'FEDERALSTATE' && (
                                                    <span className="links">
                                                        <OverlayTrigger
                                                            key={`data-${contractEntry.contract.ID}`}
                                                            placement="top"
                                                            overlay={<Tooltip
                                                                id={`tooltip-data-${contractEntry.contract.ID}`}>Mitverwendungsdaten
                                                                bearbeiten</Tooltip>}
                                                        >
                                                            <a href={`/mdb/institute/employment/details/${contractEntry.contract.ID}`}>
                                                                <FaEdit></FaEdit>
                                                            </a>
                                                        </OverlayTrigger>
                                                    </span>
                                                )}
                                            {isInstitute && (contractEntry.contract.Status === 'NONE' || contractEntry.contract.Status === 'INITIATED') && (
                                                <span className="links">
                                                   <OverlayTrigger
                                                       key={`trash-${contractEntry.contract.ID}`}
                                                       placement="top"
                                                       overlay={<Tooltip
                                                           id={`tooltip-trash-${contractEntry.contract.ID}`}>Mitverwendung
                                                           löschen</Tooltip>}
                                                   >
                                                        <a onClick={() => requestDeleteContract(contractEntry.contract)}
                                                           style={{color: "black"}}>
                                                            <FaTrash/>
                                                        </a>
                                                   </OverlayTrigger>
                                                </span>
                                            )}
                                            {isInstitute && (contractEntry.contract.Status === 'RECTORATE') && (
                                                <span className="links">
                                                    <OverlayTrigger
                                                        key={`data-${contractEntry.contract.ID}`}
                                                        placement="top"
                                                        overlay={<Tooltip
                                                            id={`tooltip-data-${contractEntry.contract.ID}`}>Mitverwendung
                                                            kopieren</Tooltip>}
                                                    >
                                                        <a onClick={() => requestCopyContract(contractEntry.contract)}
                                                            style={{ color: "green" }}>
                                                            <FaCopy></FaCopy>
                                                        </a>
                                                    </OverlayTrigger>
                                                </span>
                                            )}
                                            {isSchool && (contractEntry.contract.Status === 'RECTORATE' || contractEntry.contract.Status === 'SCHOOL') && (
                                                <span className="links">
                                                <OverlayTrigger
                                                    key={`data-${contractEntry.contract.ID}`}
                                                    placement="top"
                                                    overlay={<Tooltip id={`tooltip-data-${contractEntry.contract.ID}`}>Mitverwendung
                                                        kommentieren</Tooltip>}
                                                >
                                                    <a onClick={() => requestSchoolComment(contractEntry.contract)}>
                                                        <FaComment/>
                                                    </a>
                                                </OverlayTrigger>
                                            </span>
                                            )}
                                            {(isInstitute || isRectorate || isHR) && (contractEntry.contract.Status === 'RECTORATE' && contractEntry.schoolYear.ID === actualSchoolYear.ID) && (
                                                <span className="links">
                                                    <OverlayTrigger
                                                        key={`data-${contractEntry.contract.ID}`}
                                                        placement="top"
                                                        overlay={<Tooltip
                                                            id={`tooltip-data-${contractEntry.contract.ID}`}>Mitverwendung
                                                            beenden</Tooltip>}
                                                    >
                                                        <a onClick={() => requestFinishContract(contractEntry.contract)}>
                                                            <FaBan/>
                                                        </a>
                                                    </OverlayTrigger>
                                                </span>
                                            )}
                                            {(isInstitute || isHR) && (contractEntry.schoolYear.ID === actualSchoolYear.ID || contractEntry.schoolYear.ID === previousSchoolYear.ID) && (
                                                <span className="links">
                                                    <OverlayTrigger
                                                        key={`data-${contractEntry.contract.ID}`}
                                                        placement="top"
                                                        overlay={<Tooltip
                                                            id={`tooltip-data-${contractEntry.contract.ID}`}>Mitarbeiterdaten bearbeiten</Tooltip>}
                                                    >
                                                        <a href={`/mdb/staff/contract/${contractEntry.contract.ID}`}>
                                                            <span style={{ color: "green" }}><FaPen></FaPen></span>
                                                        </a>
                                                    </OverlayTrigger>
                                                </span>
                                            )}
                                            {isInstitute && contractEntry.contract.Status === 'RECTORATE' && contractEntry.schoolYear.ID === previousSchoolYear.ID && (
                                                <span className="links">
                                                    <OverlayTrigger
                                                        key={`data-${contractEntry.contract.ID}`}
                                                        placement="top"
                                                        overlay={<Tooltip
                                                        id={`tooltip-data-${contractEntry.contract.ID}`}>Mitverwendung
                                                        verändern</Tooltip>}
                                                    >
                                                        <a onClick={() => requestChangeContract(contractEntry.contract)}>
                                                            <FaWrench/>
                                                        </a>
                                                    </OverlayTrigger>
                                                </span>
                                            )}
                                            {!isSchool && contractEntry.contract.Status !== 'NONE' && (
                                                <span className="links">
                                                   <OverlayTrigger
                                                       key={`info-${contractEntry.contract.ID}`}
                                                       placement="top"
                                                       overlay={<Tooltip
                                                           id={`tooltip-info-${contractEntry.contract.ID}`}>Details
                                                           zur
                                                           Mitverwendung anzeigen</Tooltip>}
                                                   >
                                                       <a onClick={() => setContractToShowHandler(contractEntry.contract)}
                                                          style={{color: "blue"}}><FaInfo/></a>
                                                   </OverlayTrigger>
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-12 text-end">
                                            {isRectorate && contractEntry.contract.Status === 'INSTITUTE' && (
                                                <span className="links">
                                                <OverlayTrigger
                                                    key={`deny-${contractEntry.contract.ID}`}
                                                    placement="top"
                                                    overlay={<Tooltip id={`tooltip-deny-${contractEntry.contract.ID}`}>Vertrag
                                                        bestätigen</Tooltip>}
                                                >
                                                <span
                                                    className="confirm-icon"
                                                    data-tip="Vertrag bestätigen"
                                                    onClick={() => handleContractConfirmation(contractEntry.contract.ID, "RECTORATE")}
                                                    style={{cursor: 'pointer', color: 'green'}}
                                                ><FaCheck/>
                                                </span>
                                                </OverlayTrigger>
                                            </span>
                                            )}
                                            {isSchool && contractEntry.contract.Status === 'RECTORATE' && (
                                                <span className="links">
                                                <OverlayTrigger
                                                    key={`deny-${contractEntry.contract.ID}`}
                                                    placement="top"
                                                    overlay={<Tooltip id={`tooltip-deny-${contractEntry.contract.ID}`}>Vertrag
                                                        bestätigen</Tooltip>}
                                                >
                                                <span
                                                    className="confirm-icon"
                                                    data-tip="Vertrag bestätigen"
                                                    onClick={() => handleContractConfirmation(contractEntry.contract.ID, "SCHOOL")}
                                                    style={{cursor: 'pointer', color: 'green'}}
                                                ><FaCheck/>
                                                </span>
                                                </OverlayTrigger>
                                            </span>
                                            )}
                                            {isRectorate && contractEntry.contract.Status === 'INSTITUTE' && contractEntry.schoolYear.ID === actualSchoolYear.ID && (
                                                <span className="links">
                                                <OverlayTrigger
                                                    key={`confirm-${contractEntry.contract.ID}`}
                                                    placement="top"
                                                    overlay={<Tooltip
                                                        id={`tooltip-confirm-${contractEntry.contract.ID}`}>Vertrag
                                                        ablehnen</Tooltip>}
                                                >
                                                <span
                                                    className="confirm-icon"
                                                    data-tip="Vertrag ablehnen"
                                                    onClick={() => handleContractConfirmation(contractEntry.contract.ID, "INITIATED")}
                                                    style={{cursor: 'pointer', color: 'red'}}
                                                >
                                                    <FaTimes/>
                                                </span>
                                                </OverlayTrigger>
                                            </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    <div className="row data-row">
                        <div className="col-6 small-font">
                            &nbsp;
                        </div>
                        <div className="col-6 small-font text-end">
                            <div className="col-12 small-font">
                                {Object.entries(instituteTotals).map(([instituteName, total]) => (
                                    <div key={instituteName}>
                                        {instituteName}: {total.toFixed(3)}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="row data-row">
                        <div className="col-6 small-font">
                            Anzahl der
                            Mitverwendungen: {sortedContracts.length && sortedContracts.filter((contractEntry) => searchContract(contractEntry)).reduce((acc, contractEntry) => {
                            return acc + 1
                        }, 0)}
                        </div>
                        <div className="col-6 small-font text-end">
                            Gesamt: {totalAllInstitutes.toFixed(3)}
                        </div>
                    </div>
                </div>
            )}
            {(isRectorate &&
                <div className="container mt-5">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8">
                            <ChartComponent contracts={sortedContracts.filter((contractEntry) => searchContract(contractEntry))}/>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Overview;